import { Grid, Skeleton } from '@mui/material'

const Loading = () => (
  <Grid container spacing={1}>
    <Grid item xs={12} md={4} minHeight="22rem">
      <Skeleton variant="rectangular" width="100%" height="100%" />
    </Grid>
    <Grid item xs={12} md={4} minHeight="22rem">
      <Skeleton variant="rectangular" width="100%" height="100%" />
    </Grid>
    <Grid item xs={12} md={4} minHeight="22rem">
      <Skeleton variant="rectangular" width="100%" height="100%" />
    </Grid>
    <Grid item xs={12} minHeight="4rem">
      <Skeleton variant="rectangular" width="100%" height="100%" />
    </Grid>
  </Grid>
)

export { Loading }
